import client from './client';

export default (function ReportingService() {
  let service;

  if (!service) {
    service = client.service('reporting');
  }

  return service;
}());
